import React, {useEffect, useState} from "react"
import {useSelector, useDispatch} from "react-redux"
import {Route, Switch} from "react-router-dom"
import alertify from "alertifyjs"

import {dtg} from "./firebase"

import Product from "./components/Product/Product"
import Hourglass from "./components/Spinner/Hourglass"
import {setProduct2d} from "./redux/actions/product2dActions"
import product from "./constants/testData"
import {setHourglassState} from "./redux/actions/hourglassAction"
import {setKey, setOptions} from "./redux/actions/dataApiActions"
import {getFbData} from "./redux/actions/fbdata"

import "alertifyjs/build/css/alertify.min.css"
import "alertifyjs/build/css/themes/default.min.css"
import { useFirebaseDtgData } from "./hooks/useFirebaseDtgData"

export const CustomTheme = React.createContext('');

/**
 * React root component
 * @component
 */

const App = () => {
  const [auth, setAuth] = useState(0)
  const [isIframe, setIsIframe] = useState(0)
  const [display, setDisplay] = useState(false);

  const [iFrameData, setIFrameData] = useState()
  const [styleToApply, setStyleToApply] = useState('default-style');

  useFirebaseDtgData(iFrameData, setDisplay, setStyleToApply);

  const dispatch = useDispatch()
  const product2d = useSelector(state => state.product2d)
  const d2Loader = useSelector(state => state.d2Loader)
  const apiKey = useSelector(state => state.apiKey)

  const defaultApiKey = "EV"

  useEffect(() => {
    if (apiKey) {
      dtg
        .doc(apiKey)
        .get()
        .then(e => {
          let data = e.data()
          if (data) {
            dispatch(getFbData(data))
            setAuth(1)
          } else {
            setAuth(-1)
            dispatch(setHourglassState(false))
          }
        })
    }
  }, [apiKey, dispatch])

  useEffect(() => {
    const inIframe = () => {
      try {
        setIsIframe(() => (window.self !== window.top ? 1 : -1))
      } catch (e) {
        setIsIframe(1)
      }
    }
    inIframe()
  }, [])

  useEffect(() => {
    const url =
      window.location !== window.parent.location
        ? document.referrer
        : document.location.origin

    let urlForRequest

    if (process.env.NODE_ENV !== "development") {
      urlForRequest = url.split("/")[2]
    } else {
      urlForRequest = `myalloverprint.com`
    }

    console.log(urlForRequest)

    const stopRequest = () => {
      window.parent.postMessage(
        JSON.stringify({
          action: "viewerReady",
        }),
        url,
      )
    }

    if (isIframe === 1) {
      window.addEventListener("message", ({data}) => {
        stopRequest()
        if (data.apiKey) {
          dispatch(setKey(data.apiKey))

          if(data.appVersion === 'dtg'){
            setIFrameData(data)
            return
          }
          setDisplay(true)

          dispatch(setHourglassState(true))

          // console.log(data)

          let newObj = {}

          if (data.selectedProd) {
            if (!data.selectedProd.price) {
              alertify.error("ERROR: price, must be not blank")
              newObj.price = 0
              // return
            }

            if (data.selectedProd.sku) {
              let query = dtg
                .doc(data.apiKey)
                .collection("DTG")
                .doc("SKU_TO_CONFIG")
                .collection("all_sku")
                .doc(data.selectedProd.sku)
                .collection("linkedConfigs")

              let configsQuery = dtg
                .doc(data.apiKey)
                .collection("DTG")
                .doc("configs")
                .collection("all_configs")

              let mapsQuery = dtg
                .doc(data.apiKey)
                .collection("DTG")
                .doc("images")
                .collection("all_images")

              let cmQuery = dtg
                .doc(data.apiKey)
                .collection("DTG")
                .doc("SKU_TO_CONFIG")
                .collection("all_sku")
                .doc(data.selectedProd.sku)

              const getSkuCm = () =>
                new Promise(resolve => {
                  cmQuery.get().then(r => resolve(r.data()))
                })

              const getPartsName = () =>
                new Promise(resolve => {
                  query.get().then(res => {
                    if (res.docs.length) {
                      let parts = res.docs.map(item => ({name: item.id}))

                      resolve(parts)
                    } else {
                      resolve([])
                      dispatch(setHourglassState(false))
                      alertify.error(
                        "ERROR: sku not found in db or no parts in db",
                      )
                    }
                  })
                })

              const getParts = () =>
                new Promise(resolve => {
                  getPartsName().then(res => {
                    let arr = res.map(
                      item =>
                        new Promise(arrResolve =>
                          query
                            .doc(item.name.trim())
                            .get()
                            .then(result =>{
                              arrResolve({name: item.name, ...result.data()})
                            }
                            ),
                        ),
                    )
                    Promise.all(arr).then(r => resolve(r))
                  })
                })

              const getConfigs = () =>
                new Promise(resolve => {
                  getParts().then(res => {
                    let arr = res.map(
                      item =>
                        new Promise(arrResolve =>
                          configsQuery
                            .doc(item.config_object_id.trim())
                            .get()
                            .then(data => {
                              if (data.data()) {
                                return arrResolve({
                                  ...item,
                                  image: data.data().image
                                    ? data.data().image
                                    : item.image,
                                  config: data.data(),
                                })
                              } else {
                                alertify.error("ERROR: data not found")
                                return
                              }
                            }),
                        ),
                    )
                    Promise.all(arr).then(r => resolve(r))
                  })
                })

              const getMaps = () =>
                new Promise(resolve => {
                  getConfigs().then(res => {
                    let arr = res.map(
                      item =>
                        new Promise(arrResolve =>
                          mapsQuery
                            .doc(item.image_map.trim())
                            .get()
                            .then(data => {
                              if (data.data()) {
                                return arrResolve({
                                  ...item,
                                  config: {...item.config, ...data.data()},
                                })
                              } else {
                                alertify.error("ERROR: imgMap not found")
                                return
                              }
                            }),
                        ),
                    )

                    Promise.all(arr).then(r => resolve(r))
                  })
                })

              const getIMG = data =>
                new Promise(resolve => {
                  dispatch(setHourglassState(true))
                  fetch(
                    `https://${urlForRequest}/wp-json/ev-admin/v1/get-image-base64`,
                    {
                      method: "POST",
                      mode: "cors",
                      cache: "no-cache",
                      credentials: "same-origin",
                      headers: {
                        "Content-Type": "application/json",
                      },
                      redirect: "follow",
                      referrerPolicy: "no-referrer",
                      body: JSON.stringify({image: data.image}),
                    },
                  )
                    .then(res => res.json())
                    .then(res => {
                      // console.log(res)

                      resolve({...data, image: res})
                    })
                    .catch(err => {
                      alertify.alert("Error", "Something went wrong :(", () => {
                        console.log(err)

                        resolve({...data, image: []})
                        dispatch(setHourglassState(false))
                        return
                      })
                    })
                })

              getMaps().then(r => {
                getSkuCm().then(conf => {
                  let configMode = r.map(item => ({
                    ...item,
                    config: {...item.config, ...conf},
                  }))

                  let final = configMode.map(item => getIMG(item))
                  Promise.all(final).then(r => {
                    // console.log("settings:", r)

                    dispatch(
                      setProduct2d({
                        ...data.selectedProd,
                        ...newObj,
                        parts: r.sort(
                          (a, b) =>
                            parseInt(a.config.index) - parseInt(b.config.index),
                        ),
                      }),
                    )
                    dispatch(setHourglassState(false))
                  })
                })
              })

              // ================
            }
          }
        }
      })
    }

    if (isIframe === -1) {
      setDisplay(true)

      dispatch(setKey(defaultApiKey))

      if (!product2d.parts.length) {
        dispatch(setProduct2d(JSON.parse(product)))
      }

      dispatch(setOptions({}))
      dispatch(setHourglassState(false))
    }
  }, [dispatch, isIframe, product2d])

  // console.log(auth, d2Loader, hourglassState)

  return !display ? null : (
    <CustomTheme.Provider value={styleToApply}>
      <div className={styleToApply}>
      <Hourglass active={d2Loader} />
      {auth === 1 && (
        <Switch>
          <Route path="/" exact>
            <Product />
          </Route>

          <Route>
            <div className="cover">Page not found.</div>
          </Route>
        </Switch>
      )}
      {auth === -1 && <div className="cover">API KEY ERROR</div>}
      </div>
    </CustomTheme.Provider>
  )
}

export default App
